import { IShowNotificationParams } from './types';

type ShowMessageType = (params: IShowNotificationParams) => void;

class ToastService {
  private showMessage: ShowMessageType | null = null;

  // Метод для установки функции showMessage
  setShowMessage(fn: ShowMessageType) {
    this.showMessage = fn;
  }

  // Метод для вызова showMessage
  show(params: IShowNotificationParams) {
    if (this.showMessage) {
      this.showMessage(params);
    } else {
      console.info('Функция showMessage еще не установлена в ToastService');
    }
  }
}

const toastService = new ToastService();

export default toastService;
